import React from 'react';
import AlertMessage from '../AlertMessage';

/**
 * Displays a message that the current order has been accessioned
 */
export default function AccessionedOrderAlert() {
	return (
		<AlertMessage type="warning">
			<strong>
				This order has been received by our lab and no more changes can be made. If you need to update your
				information, please call us at <span className="text-nowrap">800-522-4762</span>.
			</strong>
		</AlertMessage>
	);
}
